import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlinePoweroff } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import NewsPaperContentGrid from "../NewsPaperContentGrid/NewsPaperContentGrid";
import FilterFetchForm from "../FilterFetch/FilterFetchForm";
import Timer from "../SharedComponent/Timer/Timer";
import AccordianTable from "../AccordianTable/AccordianTable";
import {
  fetchParamsListData,
  fetchRegionList,
  submitDbCleanUp,
} from "../ReduxState/Actions/actionAd";
import { userLogOut } from "../ReduxState/Actions/loginAction";
import { DEF_REGION } from "../CONSTANT";
import "./Scheduler.scss";

export default function Scheduler() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { regionDatas } = useSelector((state) => state.fetchinitialmetadata);
  const [regionId, setRegionId] = useState({
    label: "",
    value: "",
  });
  const [regionOption, setRegionOption] = useState([]);
  const [selectedJacketType, setSelectedJacketType] = useState(null);
  const [selectedFrontPage, setSelectedFrontPage] = useState(null);
  const [saleType, setSaleType] = useState({label: "Main", value: "main",});
  const saleTypeOptions = [
    { label: "Main", value: "main" },
    { label: "Mini", value: "mini" },
  ];
  const signOutHandler = (e) => {
    e.preventDefault();
    dispatch(userLogOut());
    navigate("/");
  };

  const handleSelectRegion = (e) => {
    setRegionId(e);
    dispatch(submitDbCleanUp());
  };
  const [userSelectedJacket, setUserSelectedJacket] = useState(false);
  const [userSelectedFrontPage, setUserSelectedFrontPage] = useState(false);

  // useEffect(() => {
  //   if (regionId && Object.keys(regionId).length && regionId?.value) {
  //     dispatch(fetchParamsListData(regionId?.value));
  //   }
  // }, [dispatch, regionId]);

useEffect(() => {
    if (regionDatas?.length) {
        console.log("FIRST REGION", regionDatas[0]);

        const regOption = regionDatas.map((el) => ({
            label: el.name,
            value: el.id,
        }));

        setRegionOption(regOption);

        if (regOption.length) {
            setRegionId(regOption[0]);
        }
    } else {
        setRegionOption([]);
        setRegionId({
            label: "",
            value: "",
        });
    }
}, [regionDatas]);

 useEffect(() => {
    dispatch(fetchRegionList(saleType.value));
}, [dispatch, saleType]);

  return (
    <>
      <div className="logScreenTop">
        <Timer />
        <span className="sinoutFont">
          <p>Sign out</p>
          <span title="SignOut " className="signoutIcon">
            <AiOutlinePoweroff size={20} onClick={signOutHandler} />
          </span>
        </span>
      </div>
      {/*<div className="regionSelection">*/}
      {/*  <Container>*/}
      {/*    <Row className="mb-3">*/}
      {/*      <Col md={6}>*/}
      {/*        <div className="selectDrop d-flex align-items-center">*/}
      {/*          <h6 style={{fontSize: "x-large", marginRight: "30px"}}>*/}
      {/*            SALE TYPE*/}
      {/*          </h6>*/}

      {/*          <Select*/}
      {/*              options={saleTypeOptions}*/}
      {/*              value={saleType}*/}
      {/*              onChange={(e) => setSaleType(e)}*/}
      {/*              styles={{*/}
      {/*                container: (provided) => ({*/}
      {/*                  ...provided,*/}
      {/*                  flex: 1,*/}
      {/*                }),*/}
      {/*              }}*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </Col>*/}

      {/*      <Col md={6}>*/}
      {/*        <div className="selectDrop d-flex align-items-center">*/}
      {/*          <h6 style={{fontSize: "x-large", marginRight: "30px"}}>*/}
      {/*            EDITION*/}
      {/*          </h6>*/}
      {/*          <Select*/}
      {/*              name="position"*/}
      {/*              options={regionOption}*/}
      {/*              isSearchable={true}*/}
      {/*              placeholder={*/}
      {/*                <div>*/}
      {/*                  <i className="fa fa-search"></i> Select Edition Name...*/}
      {/*                </div>*/}
      {/*              }*/}
      {/*              value={regionId}*/}
      {/*              onChange={(e) => handleSelectRegion(e)}*/}
      {/*              styles={{*/}
      {/*                container: (provided) => ({*/}
      {/*                  ...provided,*/}
      {/*                  flex: 1,*/}
      {/*                }),*/}
      {/*              }}*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </Col>*/}
      {/*    </Row>*/}
      {/*  </Container>*/}
      {/*</div>*/}
      {/*<div className="filterFetchFormComponent">*/}
      {/*  <FilterFetchForm regionVal={regionId} setSelectedJacketType={setSelectedJacketType} setSelectedFrontPage={setSelectedFrontPage}/>*/}
      {/*</div>*/}

      {/*<div className="tableAdsList">*/}
      {/*  <AccordianTable regionVal={regionId}/>*/}
      {/*</div>*/}
      
      {/*<div className="newsPaperContentGridContainer">*/}
      {/*  <NewsPaperContentGrid regionVal={regionId} selectedJacketType={selectedJacketType} selectedFrontPage={selectedFrontPage}/>*/}
      {/*</div>*/}
      <div className="scheduler-layout">

        <div className="left-sidebar">

          <div className="regionSelection">
              <Row className="mb-3">

                <Col md={12}>
                  {/* SALE TYPE */}
                  <div className="selectDrop d-flex align-items-center">
                    <h6 style={{fontSize: "18px", marginRight: "15px"}}>
                      SALE TYPE
                    </h6>

                    <Select
                        options={saleTypeOptions}
                        value={saleType}
                        onChange={(e) => setSaleType(e)}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            flex: 1,
                          }),
                        }}
                    />
                  </div>
                </Col>

                <Col md={12} className="mt-3">
                  {/* EDITION */}
                  <div className="selectDrop d-flex align-items-center">
                    <h6 style={{fontSize: "18px", marginRight: "15px"}}>
                      EDITION
                    </h6>

                    <Select
                        name="position"
                        options={regionOption}
                        value={regionId}
                        isClearable
                        onChange={(e) => handleSelectRegion(e)}
                        isSearchable
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            flex: 1,
                          }),
                        }}
                    />
                  </div>
                </Col>

              </Row>
          </div>

          <FilterFetchForm
              regionVal={regionId}
              setSelectedJacketType={setSelectedJacketType}
              setSelectedFrontPage={setSelectedFrontPage}
              selectedJacketType={selectedJacketType}
              selectedFrontPage={selectedFrontPage}
              setUserSelectedJacket={setUserSelectedJacket}
              setUserSelectedFrontPage={setUserSelectedFrontPage}
          />

          <AccordianTable regionVal={regionId}/>

        </div>

        <div className="right-workspace">
          <NewsPaperContentGrid
              regionVal={regionId}
              selectedJacketType={selectedJacketType}
              selectedFrontPage={selectedFrontPage}
              setSelectedJacketType={setSelectedJacketType}
              setSelectedFrontPage={setSelectedFrontPage}
              userSelectedJacket={userSelectedJacket}
              userSelectedFrontPage={userSelectedFrontPage}
                saleType={saleType}
          />
        </div>

      </div>
    </>
  );
}
